export interface IFormOptions<T> {
  label: string;
  value: T;
}

export function getFormOptions<T extends string>(values: T[], localize: Record<T, string>): IFormOptions<T>[] {
  return values.map(value => ({
    label: localize[value] || String(value),
    value,
  }));
}
